// Sentry for /tutorials, loaded by @sentry/gatsby in place of plugin options so
// it can carry functions (beforeSend). Counsel (2026-10-29): Sentry may run
// before consent only as error reporting, so there's no performance tracing,
// no session tracking, and no URL query strings in what it sends.
import * as Sentry from "@sentry/gatsby";

declare const __SENTRY_RELEASE__: string | undefined;

// Drops the query string and fragment, which can carry UTM or other visitor data.
export function stripQuery(url: string): string {
  return url.replace(/[?#].*$/, "");
}

// The plugin injects this file into every webpack entry, including the
// server-side HTML build, so only start Sentry in the browser.
if (typeof window !== "undefined") {
  Sentry.init({
    dsn: "https://b7df0e3657b1497086533608e5a0de3b@o53943.ingest.sentry.io/4504368807870464",
    release: __SENTRY_RELEASE__,
    environment: process.env.NODE_ENV,
    enabled: process.env.NODE_ENV !== "development",
    ignoreErrors: [/page-data\/sq/],
    autoSessionTracking: false,
    beforeSend(event) {
      if (event.request) {
        if (event.request.url)
          event.request.url = stripQuery(event.request.url);
        delete event.request.query_string;
      }
      return event;
    },
    beforeBreadcrumb(breadcrumb) {
      const { data } = breadcrumb;
      if (data) {
        for (const key of ["url", "from", "to"]) {
          if (typeof data[key] === "string") data[key] = stripQuery(data[key]);
        }
      }
      return breadcrumb;
    },
  });
}
